const passengers = {
  table: {
    headers: {
      createBtn: 'Criar',
      name: 'Nome',
      email: 'E-mail',
      phone: 'Telefone',
      baseAddress: 'Endereço de casa',
      alternateAddress: 'Endereço Alternativo',
      occupationAddress: 'Escola',
      createdAt: 'Criado em',
      profile: 'Perfil',
    },
  },
};

export default passengers;
